jQuery(document).ready(function($){

  function anchoractive(){
    $('#anchornavul a').each(function(i) {
        if($(this).attr("href") == "#"+$anchorid)
        {
            $(this).addClass('active');
        }
        else {
          $(this).removeClass('active');
        }
    });
  }

 
  // if the user scrolls into a div with an anchor, and the anchor nav module is applied to this page, add/remove an active class for each of the anchor nav links
  $(window).scroll(function(){
    $somethingactive = 'false';

    if ($("div.anchor-links-nav")[0] && ($(window).width() > 1200)){ 
      $currentposition = $(window).scrollTop();

      $('.anchorwrapper').each(function() {
          $anchorid = $(this).attr("id").replace("wrapper-for-", "");
          if(($currentposition >= $(this).offset().top - (300)) && ($currentposition <= $(this).offset().top + $(this).outerHeight() - 201) ){
           $(this).addClass('active');
           anchoractive($anchorid);
           $somethingactive = 'true';
         }
         else {
          $(this).removeClass('active');
         }
      });



      $('.associatedclasswrapper').each(function() {
         $anchorid = $(this).attr('data-class');
         if(($currentposition >= $(this).offset().top - (300)) && ($currentposition <= $(this).offset().top + $(this).outerHeight() - 201) ){
          $(this).addClass('active');
          anchoractive($anchorid);
          $somethingactive = 'true';
        }
        else {
         $(this).removeClass('active');
        }
              
      });

      if ($somethingactive != 'true'){
        $anchorid = "justjunknotactive";
        anchoractive($anchorid);
      }

    }
  });
  



  // When an anchor link is clicked in the anchor nav module, this gives it a smooth scroll
  // Select all links with hashes in the anchor nav
  $('#anchornavul a[href*="#"]')
    // Remove links that don't actually link to anything out of caution
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });



});